import {Component, Input, inject} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HelperService } from '../../helper.service';

@Component({
    selector: 'nbd-share-buttons',
    templateUrl: './share-buttons.component.html',
    styleUrls: ['./share-buttons.component.scss'],
    imports: [MatIconButton, MatTooltip, MatIcon, TranslatePipe]
})
export class ShareButtonsComponent {
  clipboard = inject(Clipboard);
  private readonly hs = inject(HelperService);
  private readonly ts = inject(TranslateService);


  @Input() url?: string;
  @Input() title?: string;
  @Input() description?: string;

  webShareSupported = false;

  constructor() {
    // Check if Web Share API is supported (commonly absent on desktop browsers).
    this.webShareSupported = 'share' in navigator;
  }

  copy() {
    if (!this.url) {
      return;
    }
    this.clipboard.copy(this.url);
    this.hs.showSnackBar(this.ts.instant('common.copied'), this.ts.instant('common.ok'));
  }

  async share() {
    if (this.webShareSupported) {
      try {
        const share = {
          title: this.title,
          text: this.description,
          url: this.url
        };
        console.log(share)
        await navigator.share(share);
      } catch (error) {
        console.error('Error sharing URL:', error);
      }
    }
  }

}
